import CompanyServices from '@/services-ts/Company/CompanyServices'
import HolidayServices from '@/services-ts/Company/HolidayServices'
import PerformanceServices from '@/services-ts/Company/PerformanceServices'

const CompanyAPI = (apiCompany: string) => {
  return {
    CompanyServices: new CompanyServices(apiCompany),
    HolidayServices: new HolidayServices(apiCompany),
    PerformanceServices: new PerformanceServices(apiCompany),
  }
}

export default CompanyAPI
